import {
  ControlTypeMode,
  IFormConfig,
  IStepperConfig
} from '../../../form-fields/models/form.model';
import {
  DoctorinDataProvider,
  ReliginDataProvider
} from '../services/Religion-data-provider.service';
import {
  CurriculumDataProvider,
  GradeDataProvider,
  LevelDataProvider
} from '../services/level-data-provider.service';
import {
  BuildingOwnershipTypes,
  Countries,
  LandOwnershipTypes,
  Languages,
  MaritalStatus,
  Nationalities,
  NewRequestTypes,
  Qualifications,
  Religiones,
  StudentGender,
  TypeOfOwnerData,
  YesAndNo
} from './data';

export const ApplicationInformationConfig: IFormConfig = {
  title: {
    en: 'Application Information',
    ar: ''
  },
  isTabsView: true,
  tabsDirection: 'top',
  value: {
    applicationInfoData: {
      title: {
        en: 'Applicant Information',
        ar: 'معلومات مقدم الطلب'
      },
      value: {
        firstNameEn: {
          id: 'firstNameEn',
          label: {
            en: 'First Name (in English)',
            ar: 'الاسم الاول (باللغة الإنجليزية)'
          },
          path: 'firstNameEn',
          placeholder: {
            en: 'First Name (in English)',
            ar: 'الاسم الاول (باللغة الإنجليزية)'
          },
          type: ControlTypeMode.Text,
          validations: {},
          isReadOnly: true
        },
        firstNameAr: {
          id: 'firstNameAr',
          label: {
            en: 'First Name (in Arabic)',
            ar: 'الاسم الاول (باللغة بالعربية)'
          },
          path: 'firstNameAr',
          placeholder: {
            en: 'First Name (in Arabic)',
            ar: 'الاسم الاول (باللغة بالعربية)'
          },
          type: ControlTypeMode.Text,
          validations: {},
          isReadOnly: true
        },
        lastNameEn: {
          id: 'lastNameEn',
          label: {
            en: 'Last Name (in English)',
            ar: 'الاسم الأخير (باللغة الإنجليزية)'
          },
          path: 'applicationInfoData.lastNameEn',
          placeholder: {
            en: 'Last Name (in English)',
            ar: 'الاسم الأخير (باللغة الإنجليزية)'
          },
          type: ControlTypeMode.Text,
          validations: {},
          isReadOnly: true
        },
        lastNameAr: {
          id: 'lastNameAr',
          label: {
            en: 'Last Name (in Arabic)',
            ar: 'الاسم الأخير (باللغة بالعربية)'
          },
          path: 'applicationInfoData.lastNameAr',
          placeholder: {
            en: 'Last Name (in Arabic)',
            ar: 'الاسم الأخير (باللغة بالعربية)'
          },
          type: ControlTypeMode.Text,
          validations: {},
          isReadOnly: true
        },
        dateOfBirth: {
          id: 'DateOfBirth',
          label: {
            en: 'Date of Birth',
            ar: 'تاريخ الميلاد'
          },
          path: 'oweners.DateOfBirth',
          placeholder: {
            en: 'Date of Birth',
            ar: 'تاريخ الميلاد'
          },
          type: ControlTypeMode.Date,
          validations: {
            max: {
              message: {
                en: 'Invalid date',
                ar: 'تاريخ غير صالح'
              },
              value: new Date()
            }
          }
        },
        emiratesId: {
          id: 'emaratId',
          label: {
            en: 'Emirates ID',
            ar: 'رقم الهوية الإماراتي'
          },
          path: 'applicationInfoData.emiratesId',
          placeholder: {
            en: 'Emirates ID',
            ar: 'رقم الهوية الإماراتي'
          },
          type: ControlTypeMode.Text,
          validations: {},
          isReadOnly: true
        }
      }
    },
    contactInfoData: {
      title: {
        en: 'Contact Information',
        ar: 'معلومات التواصل'
      },
      value: {
        phoneNumber: {
          id: 'phoneNumber',
          label: {
            en: 'Phone Number',
            ar: 'رقم الموبايل'
          },
          path: 'contactInfoData.phoneNumber',
          placeholder: {
            en: 'Phone Number',
            ar: 'رقم الموبايل'
          },
          type: ControlTypeMode.Phone,
          validations: {},
          isReadOnly: true
        },
        email: {
          path: 'contactInfoData.email',
          id: 'email',
          label: {
            en: 'Email',
            ar: 'عنوان البريد الإلكتروني'
          },
          placeholder: {
            en: 'Email',
            ar: 'عنوان البريد الإلكتروني'
          },
          type: ControlTypeMode.Email,
          validations: {},
          isReadOnly: true
        },
        address: {
          id: 'address',
          label: {
            en: 'Address',
            ar: 'العنوان'
          },
          path: 'contactInfoData.address',
          placeholder: {
            en: 'Address',
            ar: 'العنوان'
          },
          type: ControlTypeMode.Text,
          validations: {}
        }
      }
    }
  }
};

export const OwenersProfilesConfig: IFormConfig = {
  title: {
    en: 'owners Profiles',
    ar: 'الملفات الشخصية'
  },
  value: {
    oweners: {
      inline: false,
      isCollapsed: true,
      title: {
        en: 'Owners Profiles Data',
        ar: 'معلومات الملفات الشخصية'
      },
      arrayItemTitlePath: 'personalDetails.fullName',
      min: 1,
      max: 10,
      confirmOnDelete: true,
      confirmMessage: {
        en: 'Are you sure you want to delete this owner?',
        ar: 'هل أنت متأكد من حذف هذا المالك'
      },
      addButtonLabel: 'services.add_owner',
      group: {
        title: { en: 'Owner Profile Data', ar: 'معلومات الملف الشخصي' },
        isTabsView: true,
        tabsDirection: 'left',
        showCompletion: true,
        value: {
          personalDetails: {
            title: {
              en: 'Personal Details',
              ar: 'المعلومات الشخصية'
            },
            value: {
              typeOfOwner: {
                id: 'owner_type',
                label: {
                  en: 'Type of Owner',
                  ar: 'نوع المالك'
                },
                path: 'oweners.typeOfOwner',
                placeholder: {
                  en: 'Type of Owner',
                  ar: 'نوع المالك'
                },
                type: ControlTypeMode.SingleSelect,
                options: TypeOfOwnerData,
                labelProp: 'name',
                valueProp: 'id',
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                },
                removeFieldOnChange: {
                  fieldPath: 'nameOfCompany',
                  value: 'Individual'
                }
              },
              nameOfCompany: {
                id: 'company_name',
                label: {
                  en: 'Name of The Institution or Company',
                  ar: 'إسم المؤسسة او الشركة'
                },
                path: 'oweners.nameOfCompany',
                placeholder: {
                  en: 'Name of The Institution or Company',
                  ar: 'إسم المؤسسة او الشركة'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              fullName: {
                id: 'full_name',
                label: {
                  en: 'Full Name',
                  ar: 'الاسم الكامل'
                },
                path: 'oweners.fullName',
                placeholder: {
                  en: 'Full Name',
                  ar: 'الاسم الكامل'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              familyName: {
                id: 'family_Name',
                label: {
                  en: 'Family Name',
                  ar: 'إسم العائلة'
                },
                path: 'oweners.familyName',
                placeholder: {
                  en: 'Family Name',
                  ar: 'إسم العائلة'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              Nickname: {
                id: 'Nickname',
                label: {
                  en: 'Nickname',
                  ar: 'اسم الشهرة'
                },
                path: 'oweners.Nickname',
                placeholder: {
                  en: 'Nickname',
                  ar: 'اسم الشهرة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              photo: {
                id: 'Photograph',
                label: {
                  en: 'Photograph',
                  ar: 'صورة شخصية'
                },
                path: 'schoolInformation.Photograph',
                placeholder: {
                  en: 'Photograph',
                  ar: 'صورة شخصية'
                },
                type: ControlTypeMode.File,
                hint: {
                  en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png',
                  ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png'
                },
                acceptedTypes: ['image/png', 'image/jpg', 'image/jpeg'],
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              criminalStatusCertificate: {
                id: 'criminal_status_certificate',
                label: {
                  en: 'Criminal Status Certificate',
                  ar: 'شهادة الحالة الجنائية '
                },
                path: 'oweners.criminalStatusCertificate',
                placeholder: {
                  en: 'Criminal Status Certificate',
                  ar: 'شهادة الحالة الجنائية '
                },
                type: ControlTypeMode.File,
                hint: {
                  en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
                  ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
                },
                acceptedTypes: [
                  'image/png',
                  'image/jpg',
                  'image/jpeg',
                  'application/pdf'
                ],
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              placeOfBirth: {
                id: 'PlaceOfBirth',
                label: {
                  en: 'Place of Birth',
                  ar: 'مكان الميلاد'
                },
                path: 'oweners.PlaceOfBirth',
                placeholder: {
                  en: 'Place of Birth',
                  ar: 'مكان الميلاد'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              dateOfBirth: {
                id: 'DateOfBirth',
                label: {
                  en: 'Date of Birth',
                  ar: 'تاريخ الميلاد'
                },
                path: 'oweners.DateOfBirth',
                placeholder: {
                  en: 'Date of Birth',
                  ar: 'تاريخ الميلاد'
                },
                type: ControlTypeMode.Date,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  },
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              currentNationality: {
                id: 'CurrentNationality',
                label: {
                  en: 'Current Nationality',
                  ar: 'الجنسية الحالية'
                },
                path: 'oweners.CurrentNationality',
                placeholder: {
                  en: 'Current Nationality',
                  ar: 'الجنسية الحالية'
                },
                type: ControlTypeMode.SingleSelect,
                options: Nationalities,
                labelProp: 'name',
                valueProp: 'id',
                sortProp: { en: 'name.en', ar: 'name.ar' },
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              previousNationality: {
                id: 'PreviousNationality',
                label: {
                  en: 'Previous Nationality',
                  ar: 'الجنسية السابقة'
                },
                path: 'oweners.PreviousNationality',
                placeholder: {
                  en: 'Previous nationality',
                  ar: 'الجنسية السابقة'
                },
                type: ControlTypeMode.SingleSelect,
                options: Nationalities,
                labelProp: 'name',
                valueProp: 'id',
                sortProp: { en: 'name.en', ar: 'name.ar' },
                validations: {}
              },
              religion: {
                id: 'Religion',
                label: {
                  en: 'Religion',
                  ar: 'الديانة'
                },
                path: 'oweners.religion',
                placeholder: {
                  en: 'Religion',
                  ar: 'الديانة'
                },
                type: ControlTypeMode.SingleSelect,
                options: Religiones,
                // dataProvider: ReliginDataProvider,
                labelProp: 'name',
                valueProp: 'id',
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              doctrine: {
                id: 'doctrine',
                label: {
                  en: 'Doctrine',
                  ar: 'المذهب'
                },
                path: 'oweners.doctrine',
                placeholder: {
                  en: 'Doctrine',
                  ar: 'المذهب'
                },
                type: ControlTypeMode.SingleSelect,
                dataProvider: DoctorinDataProvider,
                labelProp: 'name',
                valueProp: 'id',
                validations: {},
                relatedTo: 'religion'
              },
              dateOfEnterCountry: {
                id: 'DateOfEnterCountry',
                label: {
                  en: 'Date of Enter Country',
                  ar: 'تاريخ دخول الدولة'
                },
                path: 'oweners.DateOfEnterCountry',
                placeholder: {
                  en: 'Date of Enter Country',
                  ar: 'تاريخ دخول الدولة'
                },
                type: ControlTypeMode.Date,
                validations: {
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              countryEntryCenter: {
                id: 'CountryEntryCenter',
                label: {
                  en: 'Center of Entry into the Country',
                  ar: 'مركز دخول الدولة'
                },
                path: 'oweners.CountryEntryCenter',
                placeholder: {
                  en: 'Center of Entry into the Country',
                  ar: 'مركز دخول الدولة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              sponsorUponEntry: {
                id: 'SponsorUponEntry',
                label: {
                  en: 'Sponsor Upon Entry',
                  ar: 'الكفيل عند الدخول'
                },
                path: 'oweners.SponsorUponEntry',
                placeholder: {
                  en: 'Sponsor Upon Entry',
                  ar: 'الكفيل عند الدخول'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              currentSponsor: {
                id: 'CurrentSponsor',
                label: {
                  en: 'Current Sponsor',
                  ar: 'الكفيل الحالي'
                },
                path: 'oweners.CurrentSponsor',
                placeholder: {
                  en: 'Current Sponsor',
                  ar: 'الكفيل الحالي'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              occupation: {
                id: 'occupation',
                label: {
                  en: 'Occupation',
                  ar: 'المهنة'
                },
                path: 'oweners.occupation',
                placeholder: {
                  en: 'Occupation',
                  ar: 'المهنة'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              currentPlaceOfWork: {
                id: 'currentPlaceOfWork',
                label: {
                  en: 'Current Place of Work',
                  ar: 'مكان العمل الحالي'
                },
                path: 'oweners.currentPlaceOfWork',
                placeholder: {
                  en: 'Current Place of Work',
                  ar: 'مكان العمل الحالي'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              workPhone: {
                id: 'workPhone',
                label: {
                  en: 'Work Phone',
                  ar: 'رقم الهاتف الخاص بالعمل'
                },
                path: 'oweners.workPhone',
                placeholder: {
                  en: 'Work Phone',
                  ar: 'رقم الهاتف الخاص بالعمل'
                },
                type: ControlTypeMode.Phone,
                validations: {
                  phone: {
                    message: {
                      en: 'Invalid phone number',
                      ar: 'رقم الهاتف غير صالح'
                    }
                  }
                }
              },
              bank: {
                id: 'bank',
                label: {
                  en: 'Bank',
                  ar: 'البنك'
                },
                path: 'oweners.bank',
                placeholder: {
                  en: 'Bank',
                  ar: 'البنك'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              salary: {
                id: 'salary',
                label: {
                  en: 'Salary',
                  ar: 'الراتب'
                },
                path: 'oweners.salary',
                placeholder: {
                  en: 'Salary',
                  ar: 'الراتب'
                },
                type: ControlTypeMode.Number,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              }
            }
          },
          passposrtDetails: {
            title: {
              en: 'Passport Details',
              ar: 'بيانات الجواز'
            },
            value: {
              passportNumber: {
                id: 'passportNumber',
                label: {
                  en: 'Passport Number',
                  ar: 'رقم جواز السفر ساري المفعول'
                },
                path: 'oweners.passportNumber',
                placeholder: {
                  en: 'Passport',
                  ar: 'رقم جواز السفر ساري المفعول'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              placeOfIssue: {
                id: 'placeOfIssue',
                label: {
                  en: 'Passport Place of Issue',
                  ar: 'مكان إصدار الجواز'
                },
                path: 'oweners.placeOfIssue',
                placeholder: {
                  en: 'Place of Issue',
                  ar: 'مكان إصدار الجواز'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              releaseDate: {
                id: 'releaseDate',
                label: {
                  en: 'Release Date',
                  ar: 'تاريخ اصدار جواز السفر ساري المفعول'
                },
                path: 'oweners.releaseDate',
                placeholder: {
                  en: 'Release Date',
                  ar: 'تاريخ اصدار جواز السفر ساري المفعول'
                },
                type: ControlTypeMode.Date,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  },
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              expiryDate: {
                id: 'expiryDate',
                label: {
                  en: 'Expiry Date',
                  ar: 'تاريخ انتهاء جواز السفر ساري المفعول'
                },
                path: 'oweners.expiryDate',
                placeholder: {
                  en: 'Expiry Date',
                  ar: 'تاريخ انتهاء جواز السفر ساري المفعول'
                },
                type: ControlTypeMode.Date,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  },
                  min: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              passport: {
                id: 'passport',
                label: {
                  en: 'Passport',
                  ar: 'جواز السفر ساري المفعول'
                },
                path: 'oweners.passport',
                placeholder: {
                  en: 'Passport',
                  ar: 'جواز السفر ساري المفعول'
                },
                type: ControlTypeMode.File,
                hint: {
                  en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
                  ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
                },
                acceptedTypes: ['image/png', 'image/jpeg', 'application/pdf'],
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              emiratePassportLastPage: {
                id: 'emiratePassportLastPage',
                label: {
                  en: 'The last page of the UAE passport',
                  ar: 'الصفحة الأخيره من جواز السفر الاماراتى'
                },
                path: 'oweners.emiratePassportLastPage',
                placeholder: {
                  en: 'The last page of the UAE passport',
                  ar: 'الصفحة الأخيره من جواز السفر الاماراتى'
                },
                type: ControlTypeMode.File,
                hint: {
                  en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
                  ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
                },
                acceptedTypes: [
                  'image/png',
                  'image/jpeg',
                  'image/jpg',
                  'application/pdf'
                ],
                validations: {}
              }
            }
          },
          residenceDetails: {
            title: {
              en: 'Residence Details',
              ar: 'تفاصيل الإقامة'
            },
            value: {
              residenceNumber: {
                id: 'residenceNumber',
                label: {
                  en: 'Residence Number',
                  ar: 'رقم الإقامة'
                },
                path: 'oweners.residence',
                placeholder: {
                  en: 'Residence',
                  ar: 'رقم الإقامة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              placeOfIssue: {
                id: 'ResidencePlaceOfIssue',
                label: {
                  en: 'Residence Place of Issue',
                  ar: 'مكان إصدار الإقامة'
                },
                path: 'oweners.placeOfIssue',
                placeholder: {
                  en: 'Place of Issue',
                  ar: 'مكان إصدار الإقامة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              releaseDate: {
                id: 'ResidenceReleaseDate',
                label: {
                  en: 'Residence Release Date',
                  ar: 'تاريخ إصدار الإقامة'
                },
                path: 'oweners.releaseDate',
                placeholder: {
                  en: 'Residence Release Date',
                  ar: 'تاريخ إصدار الإقامة'
                },
                type: ControlTypeMode.Date,
                validations: {
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              expiryDate: {
                id: 'expiryDate',
                label: {
                  en: 'Residence Expiry Date',
                  ar: 'تاريخ انتهاء الإقامة'
                },
                path: 'oweners.expiryDate',
                placeholder: {
                  en: 'Residence Expiry Date',
                  ar: 'تاريخ انتهاء الإقامة'
                },
                type: ControlTypeMode.Date,
                validations: {
                  min: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              emiratesID: {
                id: 'emiratesID',
                label: {
                  en: 'Emirates ID',
                  ar: 'رقم الهوية الإماراتية'
                },
                path: 'oweners.emiratesID',
                placeholder: {
                  en: 'Emirates ID',
                  ar: 'رقم الهوية الإماراتية'
                },
                type: ControlTypeMode.Text,
                validations: {
                  minlength: {
                    message: {
                      en: 'emirates ID should be 15 characters',
                      ar: 'رمز الإماراتي يجب أن يكون 15 محرف'
                    },
                    value: 15
                  },
                  maxlength: {
                    message: {
                      en: 'emirates ID should be 15 characters',
                      ar: 'رمز الإماراتي يجب أن يكون 15 محرف'
                    },
                    value: 15
                  },
                  pattern: {
                    message: {
                      en: 'should include numbers only',
                      ar: 'يجب أن يحوي على أرقام فقط'
                    },
                    value: '^[0-9]*$'
                  }
                }
              },
              validEmiratesID: {
                id: 'validEmiratesID',
                label: {
                  en: 'Valid Emirates ID',
                  ar: 'الهوية الإماراتية سارية المفعول '
                },
                path: 'oweners.criminalStatusCertificate',
                placeholder: {
                  en: 'Valid Emirates ID',
                  ar: 'الهوية الإماراتية سارية المفعول '
                },
                type: ControlTypeMode.File,
                hint: {
                  en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
                  ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
                },
                acceptedTypes: ['image/png', 'image/jpeg', 'application/pdf'],
                validations: {}
              },
              residency: {
                id: 'Residency',
                label: {
                  en: 'Residency (for non-citizens)',
                  ar: 'الإقامة (لغير المواطنين)'
                },
                path: 'oweners.Residency',
                placeholder: {
                  en: 'Residency',
                  ar: 'الإقامة (لغير المواطنين)'
                },
                type: ControlTypeMode.File,
                hint: {
                  en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
                  ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
                },
                acceptedTypes: ['image/png', 'image/jpeg', 'application/pdf'],
                validations: {}
              },
              registrationSummary: {
                id: 'registrationSummary',
                label: {
                  en: 'Registration Summary (for citizens)',
                  ar: 'خلاصة القيد (للمواطنين)'
                },
                path: 'residenceDetails.registrationSummary',
                placeholder: {
                  en: 'Registration Summary (for citizens)',
                  ar: 'خلاصة القيد (للمواطنين)'
                },
                type: ControlTypeMode.File,
                hint: {
                  en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
                  ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
                },
                acceptedTypes: ['image/png', 'image/jpeg', 'application/pdf'],
                validations: {}
              }
            },
            isOptional: true
          },
          qualifying: {
            title: {
              en: 'Qualifying',
              ar: 'بيانات المؤهل الدراسي'
            },
            value: {
              qualifyingType: {
                id: 'qualifyingType',
                label: {
                  en: 'Qualifying Type',
                  ar: 'نوع المؤهل الدراسي'
                },
                path: 'oweners.qualifyingType',
                placeholder: {
                  en: 'Qualifying Type',
                  ar: 'نوع المؤهل الدراسي'
                },
                type: ControlTypeMode.SingleSelect,
                options: Qualifications,
                labelProp: 'name',
                valueProp: 'id',
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              schoole: {
                id: 'schoole',
                label: {
                  en: 'School/University',
                  ar: 'المدرسة / الجامعة'
                },
                path: 'oweners.schoole',
                placeholder: {
                  en: 'School/University',
                  ar: 'المدرسة / الجامعة'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              dateOfObtainingCertificate: {
                id: 'dateOfObtainingCertificate',
                label: {
                  en: 'Date of Obtaining Certificate',
                  ar: 'تاريخ الحصول علي الشهادة'
                },
                path: 'oweners.dateOfObtainingCertificate',
                placeholder: {
                  en: 'Date of Obtaining Certificate',
                  ar: 'تاريخ الحصول علي الشهادة'
                },
                type: ControlTypeMode.Date,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  },
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              country: {
                id: 'country',
                label: {
                  en: 'Country',
                  ar: 'الدولة'
                },
                path: 'oweners.country',
                placeholder: {
                  en: 'Country',
                  ar: 'الدولة'
                },
                type: ControlTypeMode.SingleSelect,
                options: Countries,
                labelProp: 'name',
                valueProp: 'id',
                sortProp: { en: 'name.en', ar: 'name.ar' },
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              languages: {
                id: 'languages',
                label: {
                  en: 'Languages You are Fluent in',
                  ar: 'اللغات التي تجيدها'
                },
                path: 'oweners.languages',
                placeholder: {
                  en: 'Languages You are Fluent in',
                  ar: 'اللغات التي تجيدها'
                },
                type: ControlTypeMode.MultipleSelect,
                options: Languages,
                labelProp: 'name',
                valueProp: 'id',
                validations: {},
                multiple: true
              }
            }
          },
          maritalStatusData: {
            isOptional: true,
            title: {
              en: 'Marital Status Data',
              ar: 'بيانات الحالة الإجتماعية'
            },
            value: {
              maritalStatus: {
                id: 'maritalStatus',
                path: '',
                label: {
                  en: 'Marital Status',
                  ar: 'الحالة الاجتماعية'
                },
                placeholder: {
                  en: 'Marital Status',
                  ar: 'الحالة الاجتماعية'
                },
                type: ControlTypeMode.SingleSelect,
                options: MaritalStatus,
                labelProp: 'name',
                valueProp: 'id',
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              nameOfWifeOrHusband: {
                id: 'nameOfWifeOrHusband',
                label: {
                  en: 'Name of Wife or Husband',
                  ar: 'اسم الزوجة / الزوج'
                },
                path: 'oweners.nameOfWifeOrHusband',
                placeholder: {
                  en: 'Name of Wife or Husband',
                  ar: 'اسم الزوجة / الزوج'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              nationality: {
                id: 'nationality',
                label: {
                  en: 'Nationality',
                  ar: 'الجنسية'
                },
                path: 'oweners.nationality',
                placeholder: {
                  en: 'Nationality',
                  ar: 'الجنسية'
                },
                type: ControlTypeMode.SingleSelect,
                options: Nationalities,
                labelProp: 'name',
                valueProp: 'id',
                sortProp: { en: 'name.en', ar: 'name.ar' },
                validations: {}
              },
              placeOfBirth: {
                id: 'placeOfBirth',
                label: {
                  en: 'Place of Birth',
                  ar: 'مكان الميلاد'
                },
                path: 'oweners.placeOfBirth',
                placeholder: {
                  en: 'Place of Birth',
                  ar: 'مكان الميلاد'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              dateOfBirth: {
                id: 'dateOfBirth',
                label: {
                  en: 'Date of Birth',
                  ar: 'تاريخ الميلاد'
                },
                path: 'oweners.dateOfBirth',
                placeholder: {
                  en: 'Date of Birth',
                  ar: 'تاريخ الميلاد'
                },
                type: ControlTypeMode.Date,
                validations: {
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              workplace: {
                id: 'workplace',
                label: {
                  en: 'Workplace',
                  ar: 'مكان العمل'
                },
                path: 'oweners.workplace',
                placeholder: {
                  en: 'Workplace',
                  ar: 'مكان العمل'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              occupation: {
                id: 'occupation',
                label: {
                  en: 'Occupation',
                  ar: 'المهنة'
                },
                path: 'oweners.occupation',
                placeholder: {
                  en: 'Occupation',
                  ar: 'المهنة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              }
            }
          },
          fatherMotherData: {
            title: {
              en: 'Father/Mother Data',
              ar: 'بيانات الأب والأم'
            },
            value: {
              fatherName: {
                id: 'fatherName',
                label: {
                  en: 'Father Name',
                  ar: 'إسم الأب'
                },
                path: 'fatherMotherData.fatherName',
                placeholder: {
                  en: 'Father Name',
                  ar: 'إسم الأب'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              fatherNationality: {
                id: 'fatherNationality',
                label: {
                  en: 'Father Nationality',
                  ar: 'الجنسية الأب'
                },
                path: 'fatherMotherData.fatherNationality',
                placeholder: {
                  en: 'Father Nationality',
                  ar: 'الجنسية الأب'
                },
                type: ControlTypeMode.SingleSelect,
                options: Nationalities,
                labelProp: 'name',
                valueProp: 'id',
                sortProp: { en: 'name.en', ar: 'name.ar' },
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                }
              },
              fatherPlaceOfBirth: {
                id: 'fatherPlaceOfBirth',
                label: {
                  en: "Father's Place of Birth",
                  ar: 'مكان الميلاد الأب'
                },
                path: 'fatherMotherData.fatherPlaceOfBirth',
                placeholder: {
                  en: "Father's Place of Birth",
                  ar: 'مكان الميلاد الأب'
                },
                type: ControlTypeMode.Text,
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                }
              },
              fatherDateOfBirth: {
                id: 'fatherDateOfBirth',
                label: {
                  en: 'Father Date of Birth',
                  ar: 'تاريخ ميلاد الأب'
                },
                path: 'fatherMotherData.fatherDateOfBirth',
                placeholder: {
                  en: 'Father Date of Birth',
                  ar: 'تاريخ ميلاد الأب'
                },
                type: ControlTypeMode.Date,
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              fatherWorkplace: {
                id: 'fatherWorkplace',
                label: {
                  en: 'Father Workplace',
                  ar: 'مكان وظيفة الأب'
                },
                path: 'fatherMotherData.fatherWorkplace',
                placeholder: {
                  en: 'Father Workplace',
                  ar: 'مكان وظيفة الأب'
                },
                type: ControlTypeMode.Text,
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                }
              },
              fatherOccupation: {
                id: 'fatherOccupation',
                label: {
                  en: 'Father Occupation',
                  ar: 'وظيفة الأب'
                },
                path: 'fatherMotherData.fatherOccupation',
                placeholder: {
                  en: 'Father Occupation',
                  ar: 'وظيفة الأب'
                },
                type: ControlTypeMode.Text,
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                }
              },
              motherName: {
                id: 'motherName',
                label: {
                  en: 'Mother Name',
                  ar: 'إسم الأم'
                },
                path: 'fatherMotherData.motherName',
                placeholder: {
                  en: 'Mother Name',
                  ar: 'إسم الأم'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              matherNationality: {
                id: 'motherNationality',
                label: {
                  en: 'Mother Nationality',
                  ar: 'الجنسية الأم'
                },
                path: 'fatherMotherData.motherNationality',
                placeholder: {
                  en: 'Mother Nationality',
                  ar: 'الجنسية الأم'
                },
                type: ControlTypeMode.SingleSelect,
                options: Nationalities,
                labelProp: 'name',
                valueProp: 'id',
                sortProp: { en: 'name.en', ar: 'name.ar' },
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                }
              },
              motherPlaceOfBirth: {
                id: 'motherPlaceOfBirth',
                label: {
                  en: "Mother's Place of Birth",
                  ar: 'مكان ميلاد الأم'
                },
                path: 'fatherMotherData.motherPlaceOfBirth',
                placeholder: {
                  en: "Mother's Place of Birth",
                  ar: 'مكان ميلاد الأم'
                },
                type: ControlTypeMode.Text,
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                }
              },
              motherDateOfBirth: {
                id: 'motherDateOfBirth',
                label: {
                  en: 'Mother Date of Birth',
                  ar: 'تاريخ ميلاد الأم'
                },
                path: 'fatherMotherData.motherDateOfBirth',
                placeholder: {
                  en: 'Mother Date of Birth',
                  ar: 'تاريخ ميلاد الأم'
                },
                type: ControlTypeMode.Date,
                validations: {
                  // required: {
                  //   message: {
                  //     en: 'This field is required',
                  //     ar: 'هذا الحقل مطلوب',
                  //   },
                  // },
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              }
            }
          },
          housingData: {
            title: {
              en: 'Housing Data',
              ar: 'بيانات السكن'
            },
            value: {
              region: {
                id: 'region',
                label: {
                  en: 'Region',
                  ar: 'منطقة'
                },
                path: 'housingData.region',
                placeholder: {
                  en: 'Region',
                  ar: 'منطقة'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              street: {
                id: 'street',
                label: {
                  en: 'Street',
                  ar: 'شارع'
                },
                path: 'housingData.street',
                placeholder: {
                  en: 'Street',
                  ar: 'شارع'
                },
                type: ControlTypeMode.Text,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              ownerName: {
                id: 'ownerName',
                label: {
                  en: 'Owner Name',
                  ar: 'اسم المالك'
                },
                path: 'housingData.ownerName',
                placeholder: {
                  en: 'Owner Name',
                  ar: 'اسم المالك'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              houseOrbuildingNumber: {
                id: 'houseOrbuildingNumber',
                label: {
                  en: 'House or Building Number',
                  ar: 'رقم المنزل / البناية '
                },
                path: 'housingData.houseOrbuildingNumber',
                placeholder: {
                  en: 'House or Building Number',
                  ar: 'رقم المنزل / البناية '
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              floor: {
                id: 'Floor',
                label: {
                  en: 'Floor',
                  ar: 'الطابق'
                },
                path: 'housingData.Floor',
                placeholder: {
                  en: 'Floor',
                  ar: 'الطابق'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              apartmentNumber: {
                id: 'apartmentNumber',
                label: {
                  en: 'Apartment Number',
                  ar: 'رقم الشقة'
                },
                path: 'housingData.apartmentNumber',
                placeholder: {
                  en: 'Apartment Number',
                  ar: 'رقم الشقة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              phoneNumber: {
                id: 'phoneNumber',
                label: {
                  en: 'Phone Number',
                  ar: 'رقم الهاتف'
                },
                path: 'housingData.phoneNumber',
                placeholder: {
                  en: 'Phone Number',
                  ar: 'رقم الهاتف'
                },
                type: ControlTypeMode.Phone,
                validations: {
                  phone: {
                    message: {
                      en: 'Invalid phone number',
                      ar: 'رقم الهاتف غير صالح'
                    }
                  }
                }
              },
              mobilePhoneNumber: {
                id: 'mobilePhoneNumber',
                label: {
                  en: 'Mobile Phone Number',
                  ar: 'رقم الهاتف المحمول'
                },
                path: 'housingData.mobilePhoneNumber',
                placeholder: {
                  en: 'Mobile Phone Number',
                  ar: 'رقم الهاتف المحمول'
                },
                type: ControlTypeMode.Phone,
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  },
                  phone: {
                    message: {
                      en: 'Invalid phone number',
                      ar: 'الرقم غير صالح'
                    }
                  }
                }
              },
              publicCallNumber: {
                id: 'publicCallNumber',
                label: {
                  en: 'Public Call Number',
                  ar: 'رقم الاتصال العام'
                },
                path: 'housingData.publicCallNumber',
                placeholder: {
                  en: 'Public Call Number',
                  ar: 'رقم الاتصال العام'
                },
                type: ControlTypeMode.Phone,
                validations: {
                  phone: {
                    message: {
                      en: 'Invalid phone number',
                      ar: 'الرقم غير صالح'
                    }
                  }
                }
              },
              POBoxNumber: {
                id: 'POBoxNumber',
                label: {
                  en: 'PO Box Number',
                  ar: 'رقم صندوق البريد'
                },
                path: 'housingData.POBoxNumber',
                placeholder: {
                  en: 'PO Box Number',
                  ar: 'رقم صندوق البريد'
                },
                type: ControlTypeMode.Phone,
                validations: {
                  phone: {
                    message: {
                      en: 'Invalid phone number',
                      ar: 'الرقم غير صالح'
                    }
                  },
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              }
            }
          },
          carData: {
            isOptional: true,
            title: {
              en: 'Car Details',
              ar: 'بيانات المركبة'
            },
            value: {
              carType: {
                id: 'carType',
                label: {
                  en: 'Car Type',
                  ar: 'نوع المركبة'
                },
                path: 'carDetails.carType',
                placeholder: {
                  en: 'Car Type',
                  ar: 'نوع المركبة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              licensingBody: {
                id: 'licensingBody',
                label: {
                  en: 'Licensing Body',
                  ar: 'جهة الترخيص'
                },
                path: 'carDetails.licensingBody',
                placeholder: {
                  en: 'Licensing Body',
                  ar: 'جهة الترخيص'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              carNumber: {
                id: 'carNumber',
                label: {
                  en: 'Car Number',
                  ar: 'رقم اللوحة'
                },
                path: 'carDetails.carNumber',
                placeholder: {
                  en: 'Car Number',
                  ar: 'رقم اللوحة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              plateColor: {
                id: 'plateColor',
                label: {
                  en: 'Plate Color',
                  ar: 'لون اللوحة'
                },
                path: 'carDetails.plateColor',
                placeholder: {
                  en: 'Plate Color',
                  ar: 'لون اللوحة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              drivingLicenseNumber: {
                id: 'drivingLicenseNumber',
                label: {
                  en: 'Driving License Number',
                  ar: 'رقم رخصة القيادة'
                },
                path: 'carDetails.drivingLicenseNumber',
                placeholder: {
                  en: 'Driving License Number',
                  ar: 'رقم رخصة القيادة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              placeOfIssue: {
                id: 'placeOfIssue',
                label: {
                  en: 'Place of Issue',
                  ar: 'مكان إصدار '
                },
                path: 'oweners.placeOfIssue',
                placeholder: {
                  en: 'Place of Issue',
                  ar: 'مكان إصدار '
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              releaseDate: {
                id: 'releaseDate',
                label: {
                  en: 'Release Date',
                  ar: 'تاريخ الإصدار '
                },
                path: 'oweners.releaseDate',
                placeholder: {
                  en: 'Release Date',
                  ar: 'تاريخ الإصدار '
                },
                type: ControlTypeMode.Date,
                validations: {
                  max: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              },
              expiryDate: {
                id: 'expiryDate',
                label: {
                  en: 'Expiry Date',
                  ar: 'تاريخ الإنتهاء '
                },
                path: 'oweners.expiryDate',
                placeholder: {
                  en: 'Expiry Date',
                  ar: 'تاريخ الإنتهاء '
                },
                type: ControlTypeMode.Date,
                validations: {
                  min: {
                    message: {
                      en: 'Invalid date',
                      ar: 'تاريخ غير صالح'
                    },
                    value: new Date()
                  }
                }
              }
            }
          },
          militaryData: {
            isOptional: true,
            title: {
              en: 'Military Data',
              ar: 'البيانات العسكرية'
            },
            value: {
              hasMilitaryExperience: {
                id: 'hasMilitaryExperience',
                label: {
                  en: 'Has Military Experience',
                  ar: 'هل سبق لك العمل في المجال العسكري'
                },
                path: 'militaryData.hasMilitaryExperience',
                placeholder: {
                  en: 'Has Military Experience',
                  ar: 'هل سبق لك العمل في المجال العسكري'
                },
                type: ControlTypeMode.SingleSelect,
                options: YesAndNo,
                labelProp: 'name',
                valueProp: 'id',
                validations: {}
              },
              country: {
                id: 'country',
                label: {
                  en: 'Country',
                  ar: 'الدولة'
                },
                path: 'militaryData.country',
                placeholder: {
                  en: 'Country',
                  ar: 'الدولة'
                },
                type: ControlTypeMode.SingleSelect,
                options: Countries,
                labelProp: 'name',
                valueProp: 'id',
                sortProp: { en: 'name.en', ar: 'name.ar' },
                validations: {}
              },
              militaryServiceType: {
                id: 'militaryServiceType',
                label: {
                  en: 'Military Service Type',
                  ar: 'نوع الخدمة العسكرية'
                },
                path: 'militaryData.militaryServiceType',
                placeholder: {
                  en: 'Military Service Type',
                  ar: 'نوع الخدمة العسكرية'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              rank: {
                id: 'rank',
                label: {
                  en: 'Rank',
                  ar: 'الرتبة'
                },
                path: 'militaryData.rank',
                placeholder: {
                  en: 'Rank',
                  ar: 'الرتبة'
                },
                type: ControlTypeMode.Text,
                validations: {}
              },
              militaryServiceDuration: {
                id: 'militaryServiceDuration',
                label: {
                  en: 'Military Service Duration',
                  ar: 'مدة الخدمة العسكرية'
                },
                path: 'militaryData.militaryServiceDuration',
                placeholder: {
                  en: 'Military Service Duration',
                  ar: 'مدة الخدمة العسكرية'
                },
                type: ControlTypeMode.Text,
                validations: {}
              }
            }
          },
          childrens: {
            isOptional: true,
            isCollapsed: false,
            min: 0,
            max: 10,
            id: 'childrens',
            inline: true,
            confirmOnDelete: true,
            title: {
              en: 'Children data',
              ar: 'بيانات الأبناء'
            },
            group: {
              title: {
                en: 'Son/daughter name',
                ar: 'اسم الابن / البنت'
              },
              value: {
                name: {
                  id: 'name',
                  label: {
                    en: 'Name',
                    ar: 'الاسم'
                  },
                  path: 'childrens.name',
                  placeholder: {
                    en: 'Name',
                    ar: 'الاسم'
                  },
                  type: ControlTypeMode.Text,
                  validations: {}
                }
              }
            }
          },
          relativesData: {
            confirmOnDelete: true,
            isCollapsed: false,
            title: {
              en: 'Relatives Data',
              ar: 'بيانات الأقارب'
            },
            min: 0,
            max: 10,
            id: 'relativesData',
            isOptional: true,
            inline: true,
            group: {
              title: {
                en: 'Relative Data',
                ar: 'بيانات القريب'
              },
              value: {
                name: {
                  id: 'relativeName',
                  label: {
                    en: 'Relative Name',
                    ar: 'اسم القريب'
                  },
                  path: 'relativesData.name',
                  placeholder: {
                    en: 'Relative Name',
                    ar: 'اسم القريب'
                  },
                  type: ControlTypeMode.Text,
                  validations: {}
                },
                nationality: {
                  id: 'nationality',
                  label: {
                    en: 'Nationality',
                    ar: 'الجنسية'
                  },
                  path: 'relativesData.nationality',
                  placeholder: {
                    en: 'Nationality',
                    ar: 'الجنسية'
                  },
                  type: ControlTypeMode.SingleSelect,
                  options: Nationalities,
                  labelProp: 'name',
                  valueProp: 'id',
                  sortProp: { en: 'name.en', ar: 'name.ar' },
                  validations: {}
                },
                employer: {
                  id: 'employer',
                  label: {
                    en: 'Employer',
                    ar: 'جهة العمل'
                  },
                  path: 'relativesData.employer',
                  placeholder: {
                    en: 'Employer',
                    ar: 'جهة العمل'
                  },
                  type: ControlTypeMode.Text,
                  validations: {}
                }
              }
            }
          },
          friendsData: {
            confirmOnDelete: true,
            isCollapsed: false,
            title: {
              en: 'Friends Data',
              ar: 'بيانات الأصدقاء'
            },
            min: 0,
            max: 10,
            id: 'friendsData',
            inline: true,
            isOptional: true,
            group: {
              title: {
                en: 'Friends Data',
                ar: 'بيانات الصديق'
              },
              value: {
                name: {
                  id: 'name',
                  label: {
                    en: 'Relative Name',
                    ar: 'اسم الصديق'
                  },
                  path: 'friendsData.name',
                  placeholder: {
                    en: 'Relative Name',
                    ar: 'اسم الصديق'
                  },
                  type: ControlTypeMode.Text,
                  validations: {}
                },
                nationality: {
                  id: 'nationality',
                  label: {
                    en: 'Nationality',
                    ar: 'الجنسية'
                  },
                  path: 'friendsData.nationality',
                  placeholder: {
                    en: 'Nationality',
                    ar: 'الجنسية'
                  },
                  type: ControlTypeMode.SingleSelect,
                  options: Nationalities,
                  labelProp: 'name',
                  valueProp: 'id',
                  sortProp: { en: 'name.en', ar: 'name.ar' },
                  validations: {}
                },
                employer: {
                  id: 'employer',
                  label: {
                    en: 'Employer',
                    ar: 'جهة العمل'
                  },
                  path: 'friendsData.employer',
                  placeholder: {
                    en: 'Employer',
                    ar: 'جهة العمل'
                  },
                  type: ControlTypeMode.Text,
                  validations: {}
                }
              }
            }
          },
          previousWorks: {
            confirmOnDelete: true,
            title: {
              en: 'Previous Works',
              ar: 'الأعمال التي مارستها داخل الدولة'
            },
            id: 'previous works',
            inline: true,
            isCollapsed: false,
            min: 0,
            max: 10,
            isOptional: true,
            group: {
              title: {
                en: 'Work Details',
                ar: 'تفاصيل العمل'
              },
              value: {
                name: {
                  id: 'name',
                  label: {
                    en: 'Work Name',
                    ar: 'اسم العمل'
                  },
                  path: 'previousWorks.name',
                  placeholder: {
                    en: 'Work Name',
                    ar: 'اسم العمل'
                  },
                  type: ControlTypeMode.Text,
                  validations: {}
                }
              }
            }
          },
          previousVistedCountries: {
            confirmOnDelete: true,
            title: {
              en: 'Previous Visited Countries',
              ar: 'الدول التي سبق لك زيارتها'
            },
            id: 'previousVistedCountries',
            min: 0,
            max: 10,
            inline: true,
            isCollapsed: false,
            isOptional: true,
            group: {
              title: {
                en: 'Country Details',
                ar: 'تفاصيل الدولة'
              },
              value: {
                name: {
                  id: 'name',
                  label: {
                    en: 'Country Name',
                    ar: 'اسم الدولة'
                  },
                  path: 'previousWorks.name',
                  placeholder: {
                    en: 'Country Name',
                    ar: 'اسم الدولة'
                  },
                  type: ControlTypeMode.SingleSelect,
                  options: Countries,
                  labelProp: 'name',
                  valueProp: 'id',
                  sortProp: { en: 'name.en', ar: 'name.ar' },
                  validations: {}
                }
              }
            }
          },
          previousWorkCountries: {
            confirmOnDelete: true,
            title: {
              en: 'Previous Worked Countries',
              ar: 'الدول التي سبق لك العمل معها'
            },
            id: 'previousWorkCountries',
            min: 0,
            max: 10,
            inline: true,
            isCollapsed: false,
            isOptional: true,
            group: {
              title: {
                en: 'Country Details',
                ar: 'تفاصيل الدولة'
              },
              value: {
                name: {
                  id: 'name',
                  label: {
                    en: 'Country Name',
                    ar: 'اسم الدولة'
                  },
                  path: 'previousWorks.name',
                  placeholder: {
                    en: 'Country Name',
                    ar: 'اسم الدولة'
                  },
                  type: ControlTypeMode.SingleSelect,
                  options: Countries,
                  labelProp: 'name',
                  valueProp: 'id',
                  sortProp: { en: 'name.en', ar: 'name.ar' },
                  validations: {}
                }
              }
            }
          },
          sharePercentage: {
            title: {
              en: 'Share Percnetage',
              ar: 'نسبة الشراكة'
            },
            value: {
              sharePercentage: {
                id: 'sharePercentage',
                label: {
                  en: 'Owner Share Percentage',
                  ar: 'نسبة المشاركة'
                },
                path: 'sharePercentage',
                placeholder: {
                  en: 'Owner Share Percentage',
                  ar: 'نسبة المشاركة'
                },
                precision: 2,
                type: ControlTypeMode.Number,
                validations: {
                  required: {
                    message: {
                      en: 'owner share percentage is required',
                      ar: 'نسبة المشاركة مطلوبة'
                    }
                  },
                  min: {
                    message: {
                      en: 'owner share percentage should be a number between 1 and 100',
                      ar: 'نسبة المشاركة يجب أن تكون بين ال 1 الى 100'
                    },
                    value: 0
                  },
                  max: {
                    message: {
                      en: 'owner share percentage should be a number between 1 and 100',
                      ar: 'نسبة المشاركة يجب أن تكون بين ال 1 الى 100'
                    },
                    value: 100
                  }
                  // pattern: {
                  //   message: {
                  //     en: 'Value should not be decimal',
                  //     ar: 'يجب أن لا تكون القيمة عشريًة'
                  //   },
                  //   value: /^-?[0-9]+$/
                  // }
                }
              }
            }
          }
        }
      },
      id: 'oweners',
      changeConfigOnAddOrDeleteFormArray: 'childrens'
    }
  }
};

export const SchoolInformationConfig: IFormConfig = {
  title: {
    en: 'School Information',
    ar: 'معلومات المدرسة'
  },
  isTabsView: true,
  tabsDirection: 'top',
  value: {
    schoolDetails: {
      title: {
        en: 'School Details',
        ar: 'تفاصيل المدرسة'
      },
      value: {
        requestType: {
          id: 'requestType',
          label: {
            en: 'Request Type',
            ar: 'نوع الطلب'
          },
          path: 'schoolInformation.requestType',
          placeholder: {
            en: 'Request Type',
            ar: 'نوع الطلب'
          },
          type: ControlTypeMode.SingleSelect,
          options: NewRequestTypes,
          // isReadOnly: true,
          labelProp: 'name',
          valueProp: 'id',
          // value: RequestTypes[0].id,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        arabicSchoolName: {
          id: 'arabicSchoolName',
          label: {
            en: 'Arabic School Name',
            ar: 'اسم المدرسة باللغة العربية'
          },
          path: 'schoolInformation.arabicSchoolName',
          placeholder: {
            en: 'Arabic School Name',
            ar: 'اسم المدرسة باللغة العربية'
          },
          type: ControlTypeMode.Text,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        englishSchoolName: {
          id: 'englishSchoolName',
          label: {
            en: 'English School Name',
            ar: 'اسم المدرسة باللغة الإنجليزية'
          },
          path: 'schoolInformation.englishSchoolName',
          placeholder: {
            en: 'English School Name',
            ar: 'اسم المدرسة باللغة الإنجليزية'
          },
          type: ControlTypeMode.Text,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        consultant: {
          id: 'consultant',
          label: {
            en: 'Consultant',
            ar: 'الاستشاري المعماري'
          },
          path: 'schoolInformation.consultant',
          placeholder: {
            en: 'Consultant',
            ar: 'الاستشاري المعماري'
          },
          type: ControlTypeMode.Text,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        schoolAddress: {
          id: 'schoolAddress',
          label: {
            en: 'School Address',
            ar: 'عنوان المدرسة'
          },
          path: 'schoolInformation.schoolAddress',
          placeholder: {
            en: 'School Address',
            ar: 'عنوان المدرسة'
          },
          type: ControlTypeMode.Text,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        gender: {
          id: 'Gender',
          label: {
            en: 'Type of students',
            ar: 'نوع الطلبة'
          },
          path: 'schoolInformation.gender',
          placeholder: {
            en: 'Type of students',
            ar: 'نوع الطلبة'
          },
          type: ControlTypeMode.SingleSelect,
          options: StudentGender,
          labelProp: 'name',
          valueProp: 'id',
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        locationNumber: {
          id: 'locationNumber',
          label: {
            en: 'English Location/Block number',
            ar: 'الموقع / رقم قطعة الأرض باللغة الإنجليزية'
          },
          path: 'schoolInformation.locationNumber',
          placeholder: {
            en: 'English Location/Block number',
            ar: 'الموقع / رقم قطعة الأرض باللغة الإنجليزية'
          },
          type: ControlTypeMode.Text,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        locationNumberAr: {
          id: 'locationNumberAr',
          label: {
            en: 'Arabic Location/Block number',
            ar: 'الموقع / رقم قطعة الأرض باللغة العربية'
          },
          path: 'schoolInformation.locationNumberAr',
          placeholder: {
            en: 'Arabic Location/Block number',
            ar: 'الموقع / رقم قطعة الأرض باللغة العربية'
          },
          type: ControlTypeMode.Text,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        landOwnership: {
          id: 'landOwnership',
          label: {
            en: 'Land Ownership',
            ar: 'ملكية الأرض'
          },
          path: 'schoolInformation.landOwnership',
          placeholder: {
            en: 'Land Ownership',
            ar: 'ملكية الأرض'
          },
          type: ControlTypeMode.SingleSelect,
          options: LandOwnershipTypes,
          labelProp: 'name',
          valueProp: 'id',
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        ownershipBuilding: {
          id: 'ownershipBuilding',
          label: {
            en: 'Building Ownership',
            ar: 'ملكية المبني'
          },
          path: 'schoolInformation.ownershipBuilding',
          placeholder: {
            en: 'Building Ownership',
            ar: 'ملكية المبني'
          },
          type: ControlTypeMode.SingleSelect,
          options: BuildingOwnershipTypes,
          labelProp: 'name',
          valueProp: 'id',
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        landArea: {
          id: 'landArea',
          label: {
            en: 'Land Area',
            ar: 'مساحة الأرض'
          },
          path: 'schoolInformation.landArea',
          placeholder: {
            en: 'Land Area',
            ar: 'مساحة الأرض'
          },
          type: ControlTypeMode.Number,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        buildingArea: {
          id: 'buildingArea',
          label: {
            en: 'Building Area',
            ar: 'مساحة البناء'
          },
          path: 'schoolInformation.buildingArea',
          placeholder: {
            en: 'Building Area',
            ar: 'مساحة البناء'
          },
          type: ControlTypeMode.Number,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        totalIndoorcourtArea: {
          id: 'totalIndoorcourtArea',
          label: {
            en: 'Total indoor court area',
            ar: 'إجمالي مساحة الملعب الداخلية'
          },
          path: 'schoolInformation.totalIndoorcourtArea',
          placeholder: {
            en: 'Total indoor court area',
            ar: 'إجمالي مساحة الملعب الداخلية'
          },
          type: ControlTypeMode.Number,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        totalExternalCanopyArea: {
          id: 'totalExternalCanopyArea',
          label: {
            en: 'Total Outdoor Canopy Area',
            ar: 'إجمالي مساحة المظلة الخارجية'
          },
          path: 'schoolInformation.totalExternalCanopyArea',
          placeholder: {
            en: 'Total Outdoor Canopy Area',
            ar: 'إجمالي مساحة المظلة الخارجية'
          },
          type: ControlTypeMode.Number,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        dateConstructionلآuilding: {
          id: 'dateConstructionBuilding',
          label: {
            en: 'Date Construction',
            ar: 'تاريخ إنشاء المبني'
          },
          path: 'schoolInformation.dateConstructionBuilding',
          placeholder: {
            en: 'Date Construction',
            ar: 'تاريخ إنشاء المبني'
          },
          type: ControlTypeMode.Date,
          validations: {
            max: {
              message: {
                en: 'Invalid date',
                ar: 'تاريخ غير صالح'
              },
              value: new Date()
            }
          }
        },
        phone: {
          id: 'phone',
          label: {
            en: 'Phone',
            ar: 'رقم الهاتف'
          },
          path: 'schoolInformation.phone',
          placeholder: {
            en: 'Phone',
            ar: 'رقم الهاتف'
          },
          type: ControlTypeMode.Phone,
          validations: {
            phone: {
              message: {
                en: 'Invalid phone number',
                ar: 'رقم الهاتف غير صالح'
              }
            }
          }
        },
        fax: {
          id: 'fax',
          label: {
            en: 'Fax',
            ar: 'رقم الفاكس'
          },
          path: 'schoolInformation.fax',
          placeholder: {
            en: 'Fax',
            ar: 'رقم الفاكس'
          },
          type: ControlTypeMode.Phone,
          validations: {
            phone: {
              message: {
                en: 'Invalid phone number',
                ar: 'الرقم غير صالح'
              }
            }
          }
        },
        email: {
          id: 'email',
          label: {
            en: 'Email',
            ar: 'البريد الإلكتروني '
          },
          path: 'schoolInformation.email',
          placeholder: {
            en: 'Email',
            ar: 'البريد الإلكتروني '
          },
          type: ControlTypeMode.Email,
          validations: {
            email: {
              message: {
                en: 'Invalid email',
                ar: 'البريد الإلكتروني غير صحيح'
              }
            },
            maxlength: {
              message: {
                en: 'Name cannot be more than 150 characters long',
                ar: 'الاسم يجب ان يكون أكثر من 150 حروف'
              },
              value: 150
            }
          }
        },
        applicantName: {
          id: 'applicantName',
          label: {
            en: 'Applicant Name in English',
            ar: 'إسم مقدم الطلب باللغة الانجليزية'
          },
          path: 'schoolInformation.applicantName',
          placeholder: {
            en: 'Applicant Name in English',
            ar: 'إسم مقدم الطلب باللغة الانجليزية'
          },
          type: ControlTypeMode.Text,
          validations: {},
          isReadOnly: true
        },
        applicantNameAr: {
          id: 'applicantNameAr',
          label: {
            en: 'Applicant Name in Arabic',
            ar: 'إسم مقدم الطلب باللغة العربية '
          },
          path: 'schoolInformation.applicantNameAr',
          placeholder: {
            en: 'Applicant Name in Arabic',
            ar: ' إسم مقدم الطلب باللغة العربية'
          },
          type: ControlTypeMode.Text,
          validations: {
            // required: {
            //   message: {
            //     en: 'This field is required',
            //     ar: 'هذا الحقل مطلوب',
            //   },
            // },
          },
          isReadOnly: true
        },
        relationshipSchoolBuilding: {
          id: 'relationshipSchoolBuilding',
          label: {
            en: 'Relation to School Building',
            ar: 'علاقته بمبني المدرسة'
          },
          path: 'schoolInformation.relationshipSchoolBuilding',
          placeholder: {
            en: 'Relation to School Building',
            ar: 'علاقته بمبني المدرسة'
          },
          type: ControlTypeMode.Text,
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        applicantPhone: {
          id: 'applicantPhone',
          label: {
            en: 'Applicant Phone',
            ar: 'رقم الهاتف لمقدم الطلب'
          },
          path: 'schoolInformation.applicantPhone',
          placeholder: {
            en: 'Applicant Phone',
            ar: 'رقم الهاتف لمقدم الطلب'
          },
          type: ControlTypeMode.Phone,
          validations: {
            phone: {
              message: {
                en: 'Invalid phone number',
                ar: 'الرقم غير صالح'
              }
            },
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        reservationFileSchool: {
          id: 'reservationFileSchool',
          label: {
            en: 'School Reservation File',
            ar: 'ملف الحجز الخاص بإسم المدرسة'
          },
          path: 'schoolInformation.reservationFileSchool',
          placeholder: {
            en: 'School Reservation File',
            ar: 'ملف الحجز الخاص بإسم المدرسة'
          },
          type: ControlTypeMode.File,
          hint: {
            en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
            ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
          },
          acceptedTypes: ['image/png', 'image/jpeg', 'application/pdf'],
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        engPlane: {
          id: 'engPlane',
          label: {
            en: 'The engineering plan for the school building issued by an accredited engineering office',
            ar: 'المخطط الهندسي للمبني المدرسي صادر من مكتب هندسي معتمد'
          },
          path: 'schoolInformation.engPlane',
          placeholder: {
            en: 'The engineering plan for the school building issued by an accredited engineering office',
            ar: 'المخطط الهندسي للمبني المدرسي صادر من مكتب هندسي معتمد'
          },
          type: ControlTypeMode.File,
          hint: {
            en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
            ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
          },
          acceptedTypes: [
            'image/png',
            'image/jpg',
            'image/jpeg',
            'application/pdf'
          ],
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        },
        landMap: {
          id: 'landMap',
          label: {
            en: 'A map of the land issued by the concerned authorities, showing the name of the area and the plot number',
            ar: 'خارطة الأرض الصادرة من الجهات المعنية وموضح فيها اسم المنطقة ورقم قطعة الارض'
          },
          path: 'landMap',
          placeholder: {
            en: 'A map of the land issued by the concerned authorities, showing the name of the area and the plot number',
            ar: 'خارطة الأرض الصادرة من الجهات المعنية وموضح فيها اسم المنطقة ورقم قطعة الارض'
          },
          type: ControlTypeMode.File,
          hint: {
            en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
            ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
          },
          acceptedTypes: ['image/png', 'image/jpeg', 'application/pdf'],
          validations: {
            required: {
              message: {
                en: 'This field is required',
                ar: 'هذا الحقل مطلوب'
              }
            }
          }
        }
      }
    },
    curricula: {
      id: 'curricula',
      inline: false,
      isCollapsed: true,
      title: {
        en: 'Curriculum',
        ar: 'المناهج التعليمية'
      },
      min: 1,
      max: 10,
      confirmOnDelete: true,
      confirmMessage: {
        en: 'Are you sure you want to delete this curriculum?',
        ar: 'هل أنت متأكد من حذف هذا المنهاج'
      },
      addButtonLabel: 'add_curriculum',
      group: {
        title: { en: 'Curriculum', ar: 'المناهج التعليمية' },
        isTabsView: false,
        value: {
          cirriculmDetails: {
            hideHeader: true,
            title: {
              en: 'Curriculum details',
              ar: 'تفاصيل المنهاج التعليمي'
            },
            value: {
              curriculum: {
                id: 'curriculum',
                label: {
                  en: 'Curriculum',
                  ar: 'المنهاج'
                },
                path: 'curricula.curriculum',
                placeholder: {
                  en: 'Curriculum',
                  ar: 'المنهاج'
                },
                type: ControlTypeMode.SingleSelect,
                dataProvider: CurriculumDataProvider,
                labelProp: 'name',
                valueProp: 'id',
                validations: {
                  required: {
                    message: {
                      en: 'This field is required',
                      ar: 'هذا الحقل مطلوب'
                    }
                  }
                }
              },
              stages: {
                id: 'stages',
                inline: false,
                isCollapsed: true,
                relatedTo: {
                  fieldName: 'curriculum',
                  impactedFieldPath: 'stageDetails.stage'
                },
                dataProvider: LevelDataProvider,
                title: {
                  en: 'Stages',
                  ar: 'المراحل التعليمية'
                },
                min: 1,
                max: 10,
                confirmOnDelete: true,
                confirmMessage: {
                  en: 'Are you sure you want to delete this stage?',
                  ar: 'هل أنت متأكد من حذف هذه المرحلة؟'
                },
                addButtonLabel: 'add_stage',
                group: {
                  title: { en: 'Stages', ar: 'المراحل التعليمية' },
                  isTabsView: false,
                  value: {
                    stageDetails: {
                      hideHeader: true,
                      isCollapsed: false,
                      title: {
                        en: 'Stage details',
                        ar: 'تفا��يل المرحلة التعليمية'
                      },
                      value: {
                        stage: {
                          id: 'stage',
                          label: {
                            en: 'Stage',
                            ar: 'المرحلة التعليمية'
                          },
                          path: 'stageDetails.stage',
                          placeholder: {
                            en: 'Stage',
                            ar: 'المرحلة التعليمية'
                          },
                          type: ControlTypeMode.SingleSelect,
                          dataProvider: LevelDataProvider,
                          relatedTo: 'curriculumId',
                          labelProp: 'name',
                          valueProp: 'id',
                          validations: {
                            required: {
                              message: {
                                en: 'This field is required',
                                ar: 'هذا الحقل مطلوب'
                              }
                            }
                          }
                        },
                        curriculumId: {
                          id: 'curriculumId',
                          label: {
                            en: 'curriculumId',
                            ar: 'المنهاج'
                          },
                          path: 'stageDetails.curriculumId',
                          placeholder: {
                            en: 'curriculumId',
                            ar: 'المنهاج'
                          },
                          type: ControlTypeMode.Number,
                          hidden: true,
                          validations: {
                            required: {
                              message: {
                                en: 'This field is required',
                                ar: 'هذا الحقل مطلوب'
                              }
                            }
                          }
                        },
                        grades: {
                          id: 'grades',
                          label: {
                            en: 'Grades',
                            ar: 'الصفوف الدراسية'
                          },
                          path: 'stageDetails.grades',
                          placeholder: {
                            en: 'Grades',
                            ar: 'الصفوف الدراسية'
                          },
                          type: ControlTypeMode.MultipleSelect,
                          multiple: true,
                          dataProvider: GradeDataProvider,
                          relatedTo: 'stage',
                          relatedToParent: 'curriculumId',
                          labelProp: 'name',
                          valueProp: 'id',
                          validations: {
                            required: {
                              message: {
                                en: 'This field is required',
                                ar: 'هذا الحقل مطلوب'
                              }
                            }
                          }
                        },
                        capacity: {
                          id: 'capacity',
                          label: {
                            en: 'Capacity',
                            ar: 'السعة الطلابية'
                          },
                          path: 'levelDetails.capacity',
                          placeholder: {
                            en: 'Capacity',
                            ar: 'السعة الطلابية'
                          },
                          type: ControlTypeMode.Number,
                          validations: {
                            required: {
                              message: {
                                en: 'This field is required',
                                ar: 'هذا الحقل مطلوب'
                              }
                            },
                            min: {
                              value: 1,
                              message: {
                                en: 'min value is 1',
                                ar: 'أقل قيمة ممكنة هي 1'
                              }
                            }
                          }
                        },
                        numberOfClassrooms: {
                          id: 'numberOfClassrooms',
                          label: {
                            en: ' Number of Class Rooms',
                            ar: 'عدد الفصول الدراسية'
                          },
                          path: 'levelDetails.numberOfClassrooms',
                          placeholder: {
                            en: ' Number of Class Rooms',
                            ar: 'عدد الفصول الدراسية'
                          },
                          type: ControlTypeMode.Number,
                          validations: {
                            required: {
                              message: {
                                en: 'This field is required',
                                ar: 'هذا الحقل مطلوب'
                              }
                            },
                            min: {
                              value: 1,
                              message: {
                                en: 'min value is 1',
                                ar: 'أقل قيمة ممكنة هي 1'
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

export const Attachments: IFormConfig = {
  title: {
    en: 'Attachments',
    ar: 'المرفقات'
  },
  value: {
    attachments: {
      min: 1,
      max: 10,
      confirmOnDelete: true,
      inline: true,
      isCollapsed: false,
      id: 'attachments',
      title: {
        en: 'Introduction Documents after signature',
        ar: ' وثائق التعارف بعد التوقيع'
      },
      group: {
        title: {
          en: 'Introduction Documents after signature',
          ar: ' وثائق التعارف بعد التوقيع'
        },
        value: {
          attachment: {
            id: 'attachment',
            label: {
              en: 'Introduction Documents after signature',
              ar: ' وثائق التعارف بعد التوقيع'
            },
            path: 'attachment',
            placeholder: {
              en: 'Introduction Documents after signature',
              ar: ' وثائق التعارف بعد التوقيع'
            },
            type: ControlTypeMode.File,
            hint: {
              en: 'Max file size is 3MB, Suitable files are .jpg, .jpeg, .png and pdf',
              ar: 'الحد الأقصى لحجم الملف هو 3 ميغابايت، والملفات المناسبة هي .jpg و.jpeg و.png و.pdf'
            },
            acceptedTypes: [
              'image/png',
              'image/jpg',
              'image/jpeg',
              'application/pdf'
            ],
            validations: {
              required: {
                message: {
                  en: 'This field is required',
                  ar: 'هذا الحقل مطلوب'
                }
              }
            }
          }
        }
      }
    }
  }
};

export const InitApprovalServiceSteps: IStepperConfig[] = [
  {
    title: {
      en: 'Application Information',
      ar: 'بيانات مقدم طلب'
    },
    form: ApplicationInformationConfig
  },
  {
    title: {
      en: 'Owners Profiles',
      ar: 'بيانات الملاك'
    },
    form: OwenersProfilesConfig
  },
  {
    title: {
      en: 'School Information',
      ar: 'بيانات المدرسة'
    },
    form: SchoolInformationConfig
  },
  {
    title: {
      en: 'Download Documents',
      ar: 'تحميل المرفقات'
    },
    form: {
      title: {
        en: 'Download Documents',
        ar: 'تحميل المرفقات'
      },
      value: {}
    }
  },
  {
    title: {
      en: 'Attachments',
      ar: 'المرفقات'
    },
    form: Attachments
  },
  {
    title: {
      en: 'Summary',
      ar: 'الملخص'
    },
    form: {
      title: {
        en: 'Summary',
        ar: 'الملخص'
      },
      value: {}
    }
  },
  {
    title: {
      en: 'Payment',
      ar: 'الدفع'
    },
    form: {
      title: {
        en: 'Payment',
        ar: 'الدفع'
      },
      value: {}
    }
  }
];

export enum InitApprovalServiceStepsValues {
  ApplicationInformation = 0,
  OwenersProfiles = 1,
  SchoolInformation = 2,
  DownloadDocuments = 3,
  Attachments = 4,
  Summary = 5,
  PaymentForm = 6
}
